// MFC • Looklist — crossfade + slide + zoom-out on new image
// + Overlay (headline & CTA) entrance animation on hover/focus

(() => {
  if (typeof window === 'undefined') return;
  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root){
    if (!window.gsap) return;
    const items = Array.from(root.querySelectorAll('.mfc-looklist__img'));
    const links = Array.from(root.querySelectorAll('.mfc-looklist__link'));
    const title = root.querySelector('.mfc-looklist__headline');
    const cta   = root.querySelector('.mfc-looklist__cta');

    if (!items.length || !links.length) return;

    let active = Math.max(0, Math.min(parseInt(root.dataset.initial || '0', 10), items.length - 1));
    let imageTL;   // timeline for image transition
    let overlayTL; // timeline for title/cta entrance

    // Initial state
    items.forEach((el, i) => {
      gsap.set(el, { opacity: i === active ? 1 : 0, y: i === active ? 0 : 10 });
      gsap.set(el.querySelector('img'), { scale: i === active ? 1 : 1.1 });
    });
    setTextFrom(links[active], true);
    links[active].classList.add('is-active');

    function setTextFrom(link, instant = false){
      const headline = link.dataset.headline || link.textContent.trim();
      const ctaLabel = link.dataset.cta || 'Shop collection';
      const url = link.getAttribute('href') || '#';

      title.innerHTML = headline;
      cta.textContent = ctaLabel;
      cta.setAttribute('href', url);

      if (prefersReduced()) {
        gsap.set([title, cta], { y: 0, opacity: 1 });
        return;
      }
      if (!instant) {
        overlayTL && overlayTL.kill();
        // start from below with 0 opacity
        gsap.set([title], { y: 60, opacity: 0 });
        gsap.set([cta], { y: 20, opacity: 0 });

        overlayTL = gsap.timeline({ defaults: { ease: 'power2.out' } });
        overlayTL
          .to(title, { y: 0, opacity: 1, duration: 0.48 }, 0.00) // headline first
          .to(cta,   { y: 0, opacity: 1, duration: 0.44 }, 0.04); // slight delay for CTA
      }
    }

    function activate(index){
      index = +index;
      if (index === active || index < 0 || index >= items.length) return;

      const dir = index > active ? 1 : -1;
      const from = items[active];
      const to   = items[index];

      links[active].classList.remove('is-active');
      links[index].classList.add('is-active');

      imageTL && imageTL.kill();
      if (prefersReduced()){
        gsap.set(from, { opacity: 0, y: 0 });
        gsap.set(to,   { opacity: 1, y: 0 });
        gsap.set(to.querySelector('img'), { scale: 1 });
      } else {
        imageTL = gsap.timeline({ defaults:{ ease:'power2.out' } });
        gsap.set(to, { zIndex: 2 });
        gsap.set(from, { zIndex: 1 });
        imageTL
          .to(from, { opacity: 0, y: -10*dir, duration: 0.35 }, 0)
          .fromTo(to, { opacity: 0, y: 10*dir }, { opacity: 1, y: 0, duration: 0.45 }, 0)
          .fromTo(to.querySelector('img'), { scale: 1.2 }, { scale: 1, duration: 0.8 }, 0);
      }

      // Update overlay text + animate it
      setTextFrom(links[index], false);
      active = index;
    }

    // Events
    links.forEach((a, i) => {
      a.addEventListener('mouseenter', () => activate(i));
      a.addEventListener('focus',      () => activate(i));
    });

    // Theme editor cleanup
    root._mfcDestroy = () => { imageTL && imageTL.kill(); overlayTL && overlayTL.kill(); };
  }

  function initAll(container=document){
    container.querySelectorAll('.mfc-looklist[data-section-id]').forEach((root)=>{
      if (!root._mfcInited){ init(root); root._mfcInited = true; }
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.mfc-looklist');
    if (root && root._mfcDestroy) root._mfcDestroy();
  });
})();
